import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// components

// json

// styles
import styles from './index.module.scss'

// api
import userAPI from 'apis/user'
import LoadingComponent from 'pages/profile/LoadingComponent'
import { DashboardAPIData } from 'types/nft'
import HomeNftCard from 'components/Card/HomeNFTCard'
import NftSkeletonCard from 'components/Card/NftSkeletonCard'

const HiddenSection = props => {
  const { hiddenNfts, setHiddenNfts } = props
  const dispatch = useDispatch()
  const unhideNftToken = useSelector(state => (state as any).unhideNftToken)

  const [nftList, setNftList] = useState<DashboardAPIData[]>([])
  const [allNftList, setAllNftList] = useState<DashboardAPIData[]>([])
  const [loading, setLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(false)
  const [isVisibleFetching, setIsVisibleFetching] = useState(false)
  const [rowCount, setRowCount] = useState(12)

  useEffect(() => {
    if (hiddenNfts.length > 0) setAllNftList(hiddenNfts)
    else {
      setLoading(true)
      getHiddenNftData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getHiddenNftData = () => {
    userAPI.getHiddenNFT().then(
      response => {
        let list = response.filter(item => item.nft_name !== '')
        setAllNftList(list)
        setHiddenNfts(list)
        setLoading(false)
      },
      error => {
        console.log(error)
      }
    )
  }

  useEffect(() => {
    if (unhideNftToken.length > 0) {
      let newNfts = allNftList.filter(item => item.token_id !== unhideNftToken)
      setAllNftList(newNfts)
      dispatch({ type: 'set', unhideNftToken: '' })
      dispatch({ type: 'set', isLoading: false })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unhideNftToken])

  useEffect(() => {
    if (allNftList.length > rowCount) setIsVisibleFetching(true)
    setNftList(allNftList.slice(0, rowCount))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allNftList])

  useEffect(() => {
    if (isFetching) {
      setIsFetching(false)
      if (nftList.length + rowCount > allNftList.length) {
        setNftList([...nftList, ...allNftList.slice(nftList.length, allNftList.length)])
        setIsVisibleFetching(false)
      } else {
        setNftList([...nftList, ...allNftList.slice(nftList.length, nftList.length + rowCount)])
        setIsVisibleFetching(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching])

  return (
    <section className={styles.container}>
      {loading && (
        <div className="w-full grid sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-[20px] lg:gap-[10px] xl:gap-[15px] z-10 mt-[0px] mb-[50px]">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="w-full">
              <NftSkeletonCard />
            </div>
          ))}
        </div>
      )}

      {!loading && allNftList.length === 0 && <div className={styles.comingSoon}>No artworks hidden</div>}
      <div className="w-full grid sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-[20px] lg:gap-[15px] z-10 mt-[0px] lg:mt-[0px] mb-[50px]">
        {!loading &&
          nftList.map((item: any, index) => (
            <div key={index}>
              <HomeNftCard
                image={item.asset_url}
                token_id={item.token_id}
                nftName={item.nft_name}
                assetType={item.asset_type}
                coverImage={item.cover_image_url}
                artistName={item.artist_username}
                artistImage={item.artist_profile_picture}
                isOwn={true}
                onClick={() => {}}
                key={index}
                cardType="hidden"
              />
            </div>
          ))}
      </div>
      {!loading && isVisibleFetching && (
        <div className="w-full mt-[80px] mb-[40px]">
          <LoadingComponent isFetching={isFetching} setIsFetching={setIsFetching} text="Loading your hidden artwork" />
        </div>
      )}
    </section>
  )
}

export default HiddenSection
